import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TooltipModule } from 'primeng/tooltip';
import { MessageService, ConfirmationService } from 'primeng/api';
import { OrigenVentaService } from '../../../core/services/origen-venta.service';
import { OrigenVenta } from '../../../shared/models/system';

@Component({
  selector: 'app-origen-venta-admin',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    ToastModule,
    ConfirmDialogModule,
    TooltipModule
  ],
  providers: [MessageService, ConfirmationService],
  templateUrl: './origen-venta-admin.html',
  styleUrls: ['./origen-venta-admin.css']
})
export class OrigenVentaAdminComponent implements OnInit {
  list: OrigenVenta[] = [];
  item: Partial<OrigenVenta> = {};
  dialog: boolean = false;
  submitted: boolean = false;

  constructor(
    private service: OrigenVentaService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.load();
  }

  load() {
    this.service.getAll().subscribe({
      next: (data) => {
        this.list = data;
        this.cdr.detectChanges();
      }
    });
  }

  openNew() {
    this.item = { isActive: true };
    this.submitted = false;
    this.dialog = true;
  }

  edit(row: OrigenVenta) {
    this.item = { ...row };
    this.dialog = true;
  }

  save() {
    this.submitted = true;
    if (this.item.nombreOrigenVenta?.trim()) {
      const req = this.item.id
        ? this.service.update(this.item.id, this.item as OrigenVenta)
        : this.service.create(this.item);
      req.subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Origen de venta guardado' });
          this.load();
          this.dialog = false;
        }
      });
    }
  }

  toggle(row: OrigenVenta) {
    this.confirmationService.confirm({
      message: `¿${row.isActive ? 'Desactivar' : 'Activar'} ${row.nombreOrigenVenta}?`,
      header: 'Confirmar Estado',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.service.toggle(row.id).subscribe(() => this.load());
      }
    });
  }
}
